import { useState, useRef } from 'react'
import { useRecoilState } from 'recoil'
import clsx from 'clsx'
import IconChevronDown from '@/components/icons/IconChevronDown'
import useOnClickOutside from '@/hooks/useOnClickOutside'
import { marketListState } from '@/recoil/Market'

const DEFAULT_ORDER_SIDE_FILTER = 'All Markets'

export default function MarketFilter({ value, onUpdate = () => {} }) {
  const [marketList] = useRecoilState(marketListState)
  const [active, setActive] = useState(false)

  const marketFilterRef = useRef()
  useOnClickOutside(marketFilterRef, () => setActive(false))

  const isDefaultActive = value === ''
  const OptionList = [DEFAULT_ORDER_SIDE_FILTER]
    .concat(marketList)
    .map(symbol => {
      const isDefault = symbol === DEFAULT_ORDER_SIDE_FILTER
      const isActive = symbol === value || (isDefault && isDefaultActive)
      const [type, baseCurrency, quoteCurrency] = symbol.split('_')
      const marketSymbol =
        type === 'PERP'
          ? `${baseCurrency}-PERP`
          : `${baseCurrency}/${quoteCurrency}`
      return (
        <div
          key={symbol}
          className={clsx('dropdown-option', {
            active: isActive
          })}
          onClick={() => !isActive && onUpdate(isDefault ? '' : symbol)}
        >
          {isDefault ? DEFAULT_ORDER_SIDE_FILTER : marketSymbol}
        </div>
      )
    })

  const [type, baseCurrency, quoteCurrency] = value.split('_')
  const marketSymbol =
    type === 'PERP'
      ? `${baseCurrency}-PERP`
      : `${baseCurrency}/${quoteCurrency}`

  return (
    <div
      ref={marketFilterRef}
      className={clsx('dropdown noselect', { active })}
      onClick={() => setActive(v => !v)}
    >
      {isDefaultActive ? DEFAULT_ORDER_SIDE_FILTER : marketSymbol}
      <IconChevronDown className="icon-chevron-down" />
      <div className="dropdown-list">{OptionList}</div>
    </div>
  )
}
